import { render } from "./PhotoComponent.vue?vue&type=template&id=a92fa5ea&ts=true"
import script from "./PhotoComponent.vue?vue&type=script&lang=ts"
export * from "./PhotoComponent.vue?vue&type=script&lang=ts"

import "./PhotoComponent.vue?vue&type=style&index=0&id=a92fa5ea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__